import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// creates a beautiful scrollbar
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import Navbar from '../components/Admin/Navbars/Navbar';
import Footer from '../components/Admin/Footer/Footer';
import Sidebar from '../components/Admin/Sidebar/Sidebar';
// import FixedPlugin from '../components/Admin/FixedPlugin/FixedPlugin';

import { routes as baseRoutes } from '../constants';
import routes from '../routes';

import styles from '../assets/jss/material-dashboard-react/layouts/adminStyle';

import bgImage from '../assets/img/sidebar-2.jpg';
import logo from '../images/logo-white.png';
import useViewer from '../providers/Customer/useViewer';
import { PreLoader } from '../components';

let ps;

const image = bgImage;
const color = 'green';

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === baseRoutes.dashboard.pathname) {
        return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
      }
      return null;
    })}
    <Redirect from={baseRoutes.dashboard.pathname} to={`${baseRoutes.dashboard.pathname}/home`} />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  const { loading, viewer } = useViewer();
  const shouldDisplay = !loading && !!viewer;

  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  // const [image, setImage] = React.useState(bgImage);
  // const [color, setColor] = React.useState('green');
  // const [fixedClasses, setFixedClasses] = React.useState('dropdown show');
  const [mobileOpen, setMobileOpen] = React.useState(false);
  // const handleImageClick = (img) => {
  //   setImage(img);
  // };
  // const handleColorClick = (newColor) => {
  //   setColor(newColor);
  // };
  // const handleFixedClick = () => {
  //   if (fixedClasses === 'dropdown') {
  //     setFixedClasses('dropdown show');
  //   } else {
  //     setFixedClasses('dropdown');
  //   }
  // };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => window.location.pathname !== '/dashboard/maps';
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (shouldDisplay) {
      if (navigator.platform.indexOf('Win') > -1) {
        ps = new PerfectScrollbar(mainPanel.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
        document.body.style.overflow = 'hidden';
      }
      window.addEventListener('resize', resizeFunction);
      // Specify how to clean up after this effect:
      return function cleanup() {
        if (navigator.platform.indexOf('Win') > -1) {
          ps.destroy();
          document.body.style.overflow = 'auto';
        }
        window.removeEventListener('resize', resizeFunction);
      };
    }
    return undefined;
  }, [mainPanel, shouldDisplay]);

  if (!shouldDisplay) return <PreLoader />;
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={''}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        customerName={viewer && viewer.lastName}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar routes={routes} handleDrawerToggle={handleDrawerToggle} {...rest} />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
